import { Menu } from 'element-ui'

const YMenu = Menu
YMenu.$depends = [Menu]
YMenu.$name = 'y-menu'
YMenu._name = 'Menu 导航菜单'

export default YMenu
